var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.775 1.92847C5.8328 1.92847 3.35272 3.93759 2.86891 6.61368H2.43897C1.80003 6.61368 1.28564 7.12808 1.28564 7.76704V11.0695C1.28564 11.7085 1.80003 12.2229 2.43897 12.2229H2.99186C3.63081 12.2229 4.14519 11.7085 4.14519 11.0695V7.56948C4.14519 5.21312 6.17454 3.29012 8.77553 3.29012C11.3766 3.29012 13.4059 5.21312 13.4059 7.56948V11.2671C13.4059 13.6234 11.3766 15.5457 8.77553 15.5457C8.39947 15.5457 8.09466 15.8506 8.09472 16.2267C8.09476 16.6027 8.39953 16.9075 8.77553 16.9075C11.7178 16.9075 14.1978 14.8988 14.6816 12.2229H15.1114C15.7504 12.2229 16.2647 11.7085 16.2647 11.0695V7.76704C16.2647 7.12808 15.7504 6.61368 15.1114 6.61368H14.6816C14.1978 3.93759 11.7178 1.92847 8.77553 1.92847H8.775ZM7.48656 11.8399C7.1087 11.8399 6.79138 12.1571 6.91925 12.5107C7.19367 13.27 7.92089 13.8127 8.77483 13.8127C9.62881 13.8127 10.3561 13.27 10.6306 12.5107C10.7584 12.1571 10.4411 11.8399 10.0633 11.8399H7.48656Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help-center.f620936b306d8d4eaf3acba69b458653.svg";
export { ForwardRef as ReactComponent };